// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"d97e79cb","415":"4a0461e0","513":"962b6c09","787":"987a7a6d"}[chunkId] + ".chunk.js";
};